/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ESA
 *
 * 1 = MOT
 *
 * 2 = Recall
 *
 * 3 = VDI
 */
export enum PurchasePlannerServiceCheckEnum {
  ESA = 0,
  MOT = 1,
  Recall = 2,
  VDI = 3,
}
